export default "__VITE_ASSET__54268f31__"